/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `Bug/Issue with the System` - BUG
 * `Buyer Issues` - BUYER_ISSUES
 * `Claims` - CLAIMS
 * `Company` - COMPANY
 * `Credit Notes` - CREDIT_NOTES
 * `CRM` - CRM
 * `Customer Product Support` - CUSTOMER_PRODUCT_SUPPORT
 * `Data Change Request` - DATA_CHANGE_REQUEST
 * `Debit Note` - DEBIT_NOTE
 * `Delivery Update` - DELIVERY_UPDATE
 * `Documentation` - DOCUMENTATION
 * `General` - GENERAL
 * `Fields (e.g. Materials and Ports)` - FIELDS
 * `Finance` - FINANCE
 * `Inspections` - INSPECTIONS
 * `Invoice Adjustments` - INVOICE_ADJUSTMENTS
 * `JIRA` - JIRA
 * `Licenses` - LICENSES
 * `Legal Contract Review` - LEGAL_CONTRACT_REVIEW
 * `Loading Update` - LOADING_UPDATE
 * `New Material` - NEW_MATERIAL
 * `New Trade Lane` - NEW_TRADE_LANE
 * `Payments` - PAYMENTS
 * `PERN` - PERN
 * `Pre-Payments` - PRE_PAYMENTS
 * `Product Feature Request` - PRODUCT_FEATURE_REQUEST
 * `Regulations` - REGULATIONS
 * `Supplier Issues` - SUPPLIER_ISSUES
 * `Terms & Conditions` - TERMS_CONDITIONS
 * `Transport Issues` - TRANSPORT_ISSUES
 */
export type RequestCategoryEnum = (typeof RequestCategoryEnum)[keyof typeof RequestCategoryEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestCategoryEnum = {
  'Bug/Issue_with_the_System': 'Bug/Issue with the System',
  Buyer_Issues: 'Buyer Issues',
  Claims: 'Claims',
  Company: 'Company',
  Credit_Notes: 'Credit Notes',
  CRM: 'CRM',
  Customer_Product_Support: 'Customer Product Support',
  Data_Change_Request: 'Data Change Request',
  Debit_Note: 'Debit Note',
  Delivery_Update: 'Delivery Update',
  Documentation: 'Documentation',
  General: 'General',
  'Fields_(eg_Materials_and_Ports)': 'Fields (e.g. Materials and Ports)',
  Finance: 'Finance',
  Inspections: 'Inspections',
  Invoice_Adjustments: 'Invoice Adjustments',
  JIRA: 'JIRA',
  Licenses: 'Licenses',
  Legal_Contract_Review: 'Legal Contract Review',
  Loading_Update: 'Loading Update',
  New_Material: 'New Material',
  New_Trade_Lane: 'New Trade Lane',
  Payments: 'Payments',
  PERN: 'PERN',
  'Pre-Payments': 'Pre-Payments',
  Product_Feature_Request: 'Product Feature Request',
  Regulations: 'Regulations',
  Supplier_Issues: 'Supplier Issues',
  'Terms_&_Conditions': 'Terms & Conditions',
  Transport_Issues: 'Transport Issues',
} as const;
